import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { EquipmentRental } from 'app/models2/rental/equipment-rental';
import { RentalOrder } from 'app/models2/rental/rental-order';
import { RentalRegister } from 'app/models2/rental/rental-register';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, TableColumns, TableConfiguration } from 'brainloper-ui';

@Component({
  selector: 'app-rental-order-summary',
  templateUrl: './rental-order-summary.component.html',
  styleUrls: ['./rental-order-summary.component.scss']
})
export class RentalOrderSummaryComponent implements OnInit {

  @Input() rentalOrderDetails = new RentalOrder

  public data = new RentalOrder
  public dataS:RentalRegister[] = []
  public dataEquipments: Array<EquipmentRental> = [];

  public configurationEquipments: TableConfiguration = {
    hideTitle: true,
    primaryKey: 'id',
  };
  public columnsEquipments: TableColumns<EquipmentRental>[] = [
    {
      ID: 'equipmentCode',
      label: 'Código Equipo',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'equipmentName',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'rentalCost',
      label: 'Costo Alquiler',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    }
  ];

  constructor(
    private http: HttpService,
    private functionEter: FunctionsService,
  ) { }

  ngOnInit(): void {
    this.initializeDetailsValues()
  }

  async initializeDetailsValues(){
     let res: Array<RentalOrder>  = []
      res = await this.http.getDataBody<Array<RentalOrder>>(`${EndpointDictionary.RentalOrder.CRUD_RENTAL_ORDER}/${this.rentalOrderDetails.id}`)
      if(res){
        this.data = res[0]
        this.dataEquipments = res[0].equipments
        this.data.startDate = this.functionEter.dateWithTime(this.data.startDate)     
        this.data.endDate = this.functionEter.dateWithTime(this.data.endDate)
      }

  }

}
